import _ from "lodash";
import {
  ADD_URL_TO_LIST_SUCCESS,
  CHECK_URL_CHANGE,
  CHECK_URL_FAILURE,
  CHECK_URL_SUCCESS,
  CLEAR_CHECK_URL,
  CANCEL_CHECK_URL,
  CLEAR_CSV_FILE,
  LOADING_SUCCESS,
  PARSE_CSV_FILE_FAILURE,
  REMOVE_ITEMS_SUCCESS,
  UPLOAD_CSV_FILE_FAILURE,
  CHECK_CSV_FILE_FAILURE,
  CHECK_CSV_FILE_SUCCESS,
  PARSE_CSV_FILE,
  UPLOAD_CSV_FILE_PARTIAL_SUCCESS,
} from "./urlFilters.types";
import { CsvNotificationType } from "./components/uploadCsvBlock/notifications";

const initialState = {
  checkUrlState: {
    url: "",
    status: null,
    parsedURL: {},
  },
  uploadUrlsState: {
    fileName: "",
    siteList: [],
    validation: {
      type: "",
      message: "",
      messageValues: null,
      detailedMessages: [],
    },
    isUploadFailed: false,
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_SUCCESS: {
      return { ...state, ...action.payload };
    }
    case ADD_URL_TO_LIST_SUCCESS: {
      const { list, item, profileId } = action.payload;
      const newItems = _.uniq(
        _.concat(_.get(state[profileId], `${list}.content`), item)
      );
      return {
        ...state,
        [profileId]: {
          ...state[profileId],
          [list]: {
            ...state[profileId][list],
            content: newItems,
            total: newItems.length,
          },
        },
      };
    }
    case REMOVE_ITEMS_SUCCESS: {
      const { list, items, profileId } = action.payload;
      const isOneItem = items.length === 1;
      const newItems =
        isOneItem &&
        _.without(_.get(state[profileId], `${list}.content`), ...items);

      return {
        ...state,
        [profileId]: {
          ...state[profileId],
          [list]: {
            ...state[profileId][list],
            content: isOneItem ? newItems : [],
            total: isOneItem ? newItems.length : 0,
          },
        },
      };
    }

    case CHECK_URL_CHANGE: {
      const { url } = action.payload;
      return { ...state, checkUrlState: { ...state.checkUrlState, url: url } };
    }
    case CHECK_URL_SUCCESS: {
      const { urls } = action.payload;
      return {
        ...state,
        checkUrlState: {
          ...state.checkUrlState,
          parsedURL: urls,
          status: "success",
        },
      };
    }
    case CHECK_URL_FAILURE: {
      return {
        ...state,
        checkUrlState: { ...state.checkUrlState, status: "error" },
      };
    }
    case CLEAR_CHECK_URL: {
      return {
        ...state,
        checkUrlState: { url: "", parsedURL: {}, status: null },
      };
    }
    case CANCEL_CHECK_URL: {
      return {
        ...state,
        checkUrlState: { ...state.checkUrlState, parsedURL: {}, status: null },
      };
    }
    case CHECK_CSV_FILE_SUCCESS: {
      return {
        ...state,
        uploadUrlsState: {
          ...state.uploadUrlsState,
          ...action.payload,
          validation: {
            type: "",
            message: "",
            messageValues: null,
            detailedMessages: [],
          },
          isUploadFailed: false,
        },
      };
    }
    case PARSE_CSV_FILE_FAILURE:
    case CHECK_CSV_FILE_FAILURE: {
      const { fileName, errorMessage, errorList = [] } = action.payload;

      return {
        ...state,
        uploadUrlsState: {
          ...state.uploadUrlsState,
          fileName,
          validation: {
            type: CsvNotificationType.Error,
            message: errorMessage,
            messageValues: null,
            detailedMessages: errorList,
          },
          isUploadFailed: true,
        },
      };
    }

    case UPLOAD_CSV_FILE_FAILURE: {
      const {
        errorMessage,
        errorList = [],
        errorMessageValues,
      } = action.payload;
      return {
        ...state,
        uploadUrlsState: {
          ...state.uploadUrlsState,
          validation: {
            type: CsvNotificationType.Error,
            message: errorMessage,
            detailedMessages: errorList,
            messageValues: errorMessageValues,
          },
          isUploadFailed: true,
        },
      };
    }
    case UPLOAD_CSV_FILE_PARTIAL_SUCCESS: {
      const {
        warningMessage,
        warningList = [],
        warningMessageValues,
      } = action.payload;
      return {
        ...state,
        uploadUrlsState: {
          ...state.uploadUrlsState,
          validation: {
            type: CsvNotificationType.Warning,
            message: warningMessage,
            messageValues: warningMessageValues,
            detailedMessages: warningList,
          },
          isUploadFailed: true,
        },
      };
    }
    case PARSE_CSV_FILE:
    case CLEAR_CSV_FILE: {
      return {
        ...state,
        uploadUrlsState: { ...initialState.uploadUrlsState },
      };
    }
    default:
      return state;
  }
};
